module.exports = __webpack_public_path__ + "img/State=7.7503102a.svg";